import { render, staticRenderFns } from "./AccountToolbarItem.vue?vue&type=template&id=45b1cc9e&scoped=true&"
import script from "./AccountToolbarItem.vue?vue&type=script&lang=ts&"
export * from "./AccountToolbarItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1cc9e",
  null
  
)

export default component.exports